import React from 'react';
import { commands, executeCommand, selectWord } from '@uiw/react-md-editor';

const underline = {
  name: 'underline',
  keyCommand: 'underline',
  shortcuts: 'ctrlcmd+u',
  prefix: '_',
  buttonProps: {
    'aria-label': 'Add underline text (ctrl + u)',
    title: 'Add underline text (ctrl + u)',
  },
  icon: (
    <svg width="12" height="12" viewBox="0 0 448 512">
      <path
        fill="currentColor"
        d="M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
      />
    </svg>
  ),
  execute: (state, api) => {
    const newSelectionRange = selectWord({
      text: state.text,
      selection: state.selection,
      prefix: state.command.prefix,
    });
    const newState = api.setSelectionRange(newSelectionRange);
    executeCommand({
      api,
      selectedText: newState.selectedText,
      selection: state.selection,
      prefix: state.command.prefix,
    });
  },
};

export const markdownEditorCommands = [
  commands.group(
    [
      commands.heading1,
      commands.heading2,
      commands.heading3,
      commands.heading4,
      commands.heading5,
      commands.heading6,
    ],
    {
      name: 'heading',
      groupName: 'heading',
      buttonProps: {
        'aria-label': 'Insert heading',
        title: 'Insert heading',
      },
    },
  ),
  commands.bold,
  commands.italic,
  commands.strikethrough,
  underline,
  commands.divider,
  commands.unorderedListCommand,
  commands.orderedListCommand,
];

export const markdownEditorExtraCommands = [];
